export default __webpack_public_path__ + "static/media/wink.cfc1f9c6.svg";